import React from "react";
import { Grid, Divider, Box } from "@financeable-com-au/financeable-ui";
import { LenderCardProvider } from "@/providers/LenderCardContextProvider";
import { QuoteCalculator } from "./QuoteCalculator";
import { QuoteDisplay } from "./QuoteDisplay";

const ManualQuote = React.memo(() => {

  return (
    <Grid container spacing={2} padding={6} direction="column" sm={12}>
      <LenderCardProvider productDetails={undefined} showRequiredFields={() => {}} isSingleLenderProduct={false}>
        <QuoteDisplay />
        <Box py={6}>
          <Divider />
        </Box>
        <QuoteCalculator />
      </LenderCardProvider>
    </Grid>
  );
});

export { ManualQuote };
